<template>
  <svg width="16" height="18" viewBox="0 0 16 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.44141 16.713V1.28711H14.5557V16.713L8.09835 10.9283L1.44141 16.713Z" stroke="currentColor" stroke-width="1.96714" stroke-linejoin="round" />
  </svg>
</template>
